import React from 'react'
import { motion } from "framer-motion"
import PageTitle from '../components/common/pageTitle'
import { Link, ScrollRestoration } from 'react-router-dom'
import { slideUp } from '../utlits/slideUp'

const PrivacyPolicy = () => {
  return (
    <>
      <PageTitle link={"Privacy Policy"} pageName={"Privacy Policy"} />
      <div className="terms-conditions-area pt-100 pb-75">
        <div className="container">
          <motion.div className="terms-conditions-content"
            initial="offscreen"
            whileInView="onscreen"
            variants={slideUp(1)}
            viewport={{ once: true, amount: 0.1 }}
          >
            <div className="title">
    <h3>Introduction</h3>
    <p>J5 Consulting and Education LLC DBA: J5 Solutions SP ("we," "us," or "our") is committed to protecting your privacy. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you visit our website and register for our classes.</p>
    <p>By using our website and registering for classes, you consent to the collection and use of your information as described in this Privacy Policy.</p>
</div>

<div className="title">
    <h3>Information We Collect</h3>
    <p>When you register for our classes, we collect personal information including your full name, email address, phone number, mailing address (if required), and any additional information you provide in registration forms. Payment information is processed securely through QuickBooks.</p>
    <p>We may also automatically collect information such as your IP address, browser type and version, device information, pages visited and time spent on our site, and data from cookies and similar tracking technologies.</p>
</div>

<div className="title">
    <h3>How We Use Your Information</h3>
    <p>We use your information to process class registrations, send confirmation emails and class-related communications, process payments through QuickBooks, and provide customer support. We also use this information to improve our website and services, send important updates about your classes, and comply with legal obligations.</p>
    <p>All communications related to your class registration are essential for providing our services and ensuring you receive important updates about your enrolled classes.</p>
</div>

<div className="title">
    <h3>Information Sharing and Disclosure</h3>
    <p>We share your information with trusted third-party service providers including <strong>QuickBooks</strong> for payment processing and invoicing, and <strong>Make.com</strong> for automated email communications and workflow management. These providers are bound by confidentiality agreements and may only use your information to provide services to us.</p>
    <p>We do not sell, trade, or rent your personal information to third parties for marketing purposes. We may disclose your information if required by law, court order, or government regulation.</p>
</div>

<div className="title">
    <h3>Data Security</h3>
    <p>We implement appropriate technical and organizational measures to protect your personal information against unauthorized access, alteration, disclosure, or destruction. This includes secure data transmission, encrypted storage, and regular security assessments of our systems and third-party providers.</p>
    <p>However, no method of transmission over the internet is 100% secure, and we cannot guarantee absolute security of your information.</p>
</div>

<div className="title">
    <h3>Data Retention</h3>
    <p>We retain your personal information for as long as necessary to provide our services, comply with legal obligations, resolve disputes, and enforce our agreements. Class registration data is retained for 7 years and email communications for 3 years.</p>
    <p>You may request deletion of your personal information at any time, subject to legal and contractual obligations.</p>
</div>

<div className="title">
    <h3>Your Rights</h3>
    <p>You have the right to access your personal information, correct inaccurate information, request deletion of your information, and opt-out of marketing communications. You may also withdraw consent where applicable and request a copy of your personal data.</p>
    <p>To exercise these rights, contact us at j5solutionssp@gmail.com. We will respond to your request within 30 days and may require verification of your identity.</p>
</div>

<div className="title">
    <h3>Email Communications</h3>
    <p>We send emails related to your class registration including registration confirmations, class reminders, important updates, and payment notifications. These communications are essential for providing our services and ensuring you receive critical information about your enrolled classes.</p>
    <p>We may also send promotional emails about new classes and services. You can opt-out of marketing communications at any time using the unsubscribe link in emails, but you cannot opt-out of essential service-related communications.</p>
</div>

<div className="title">
    <h3>Cookies and Tracking Technologies</h3>
    <p>We use cookies to remember your preferences, improve website functionality, and analyze website usage. Cookies help us provide a better user experience and understand how visitors interact with our site.</p>
    <p>You can control cookies through your browser settings. Disabling cookies may affect website functionality and your ability to use certain features of our site.</p>
</div>

<div className="title">
    <h3>Children's Privacy</h3>
    <p>Our services are not intended for children under 13. We do not knowingly collect personal information from children under 13. If we become aware that we have collected personal information from a child under 13, we will take steps to delete such information.</p>
    <p>If you are a parent or guardian and believe your child has provided us with personal information, please contact us immediately.</p>
</div>

<div className="title">
    <h3>California Privacy Rights</h3>
    <p>California residents have additional rights under the California Consumer Privacy Act (CCPA), including the right to know what personal information is collected, the right to delete personal information, the right to opt-out of sale of personal information, and the right to non-discrimination.</p>
    <p>To exercise these rights, California residents may contact us using the information provided below. We do not sell personal information to third parties.</p>
</div>

<div className="title">
    <h3>Changes to This Privacy Policy</h3>
    <p>We may update this Privacy Policy periodically to reflect changes in our practices or legal requirements. Changes will be posted on this page with an updated "Last Updated" date. We encourage you to review this policy regularly.</p>
    <p>Continued use of our services after changes constitutes acceptance of the updated policy. For significant changes, we may provide additional notice through email or website notifications.</p>
</div>

<div className="title">
    <h3>Contact Information</h3>
    <p>For questions about this Privacy Policy, to exercise your rights, or to report privacy concerns, contact us at <strong>Email:</strong> j5solutionssp@gmail.com, <strong>Phone:</strong> (601)-633-1159, or visit our website at <strong>https://j5solutions.org</strong></p>
    <p>We are committed to resolving any privacy concerns promptly and will respond to your inquiries within 48 hours of receipt.</p>
</div>
          </motion.div>
        </div>
      </div>
      <ScrollRestoration />
    </>
  )
}

export default PrivacyPolicy